/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=solid&m=free */
import { faAngleDown, faAngleRight, faArchive, faArrowLeft, faArrowRight, faBars, faBookmark, faBookOpen, faVideo, faBriefcase, faCar, faChartArea, faChartBar, faChartPie, faCheck, faChevronDown, faChevronRight, faChevronUp, faClock, faCode, faColumns, faCouch, faExclamation, faExclamationTriangle, faFile, faFileAlt, faFilePdf, faFlag, faGift, faGlobe, faHome, faLongArrowAltRight, faMobileAlt, faMotorcycle, faPaperclip, faPlay, faPlus, faPlusCircle, faQuestion, faSearch, faShoppingCart, faStar, faStarHalfAlt, faStoreAlt, faTable, faTachometerAlt, faUser, faChartLine, faCamera, faFireExtinguisher, faShieldVirus, faBrain, faShieldAlt, faCertificate, faMicrochip, faBalanceScale, faLightbulb, faMapMarkedAlt, faDatabase, faLayerGroup, faGavel, faClipboardCheck, faHammer, faCog, faBuilding, faLandmark, faCompress, faSortAmountDown, faCheckDouble, faSitemap, faSearchPlus, faUserGraduate, faBell, faRobot, faCheckCircle, faCogs, faUsers, faEye, } from '@fortawesome/free-solid-svg-icons';
export const fontAwesomeSolidIcons = {
    faMicrochip,
    faBalanceScale,
    faLightbulb,
    faMapMarkedAlt,
    faBrain,
    faShieldAlt,
    faCertificate,
    faShieldVirus,
    faAngleDown,
    faAngleRight,
    faArchive,
    faArrowLeft,
    faArrowRight,
    faBars,
    faBookmark,
    faFireExtinguisher,
    faBookOpen,
    faChartLine,
    faCamera,
    faVideo,
    faBriefcase,
    faCar,
    faChartArea,
    faChartBar,
    faChartPie,
    faCheck,
    faChevronDown,
    faChevronRight,
    faChevronUp,
    faClock,
    faCode,
    faColumns,
    faCouch,
    faExclamation,
    faExclamationTriangle,
    faFile,
    faFileAlt,
    faFilePdf,
    faFlag,
    faGift,
    faGlobe,
    faHome,
    faLongArrowAltRight,
    faMobileAlt,
    faMotorcycle,
    faPaperclip,
    faPlay,
    faPlus,
    faPlusCircle,
    faQuestion,
    faSearch,
    faShoppingCart,
    faStar,
    faStarHalfAlt,
    faStoreAlt,
    faTable,
    faTachometerAlt,
    faUser,
    faDatabase,
    faLayerGroup,
    faGavel,
    faClipboardCheck,
    faHammer,
    faCog,
    faBuilding,
    faLandmark,
    faCompress,
    faSortAmountDown,
    faCheckDouble,
    faSitemap,
    faSearchPlus,
    faUserGraduate,
    faBell,
    faRobot,
    faCheckCircle,
    faCogs,
    faUsers,
    faEye,
};
